module.exports = __webpack_public_path__ + "static/scale-model-of-wayside-park-in-bakersfield-california-00fd092ce12eabbcbe5111ce725e19b5.png";